import { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { DynamicMap } from './DynamicMap';
import { SetAnchorContext } from './SetAnchorContext';
import { MapPopper } from './MapPopper';
import { MapToggle } from './MapToggle';

const useStyles = makeStyles()({
  root: {
    height: '100%',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
});

export const ConnectMap = () => {
  const { classes } = useStyles();
  const [anchor, setAnchor] = useState<{ anchorEl: HTMLButtonElement, anchorId: string }>(null);

  return (
    <div className={classes.root}>
      <MapToggle />

      <SetAnchorContext.Provider value={setAnchor}>
        <MapPopper {...anchor} />

        <DynamicMap />
      </SetAnchorContext.Provider>
    </div>
  );
};
